<div class="my--lg align-center no-data-container">
    <img [src]="imageSrc" alt="No data found" class="no-data-image">
    <p class="mt--md align-center color--navy">{{ message | translate }}</p>
</div>